<template>
  <div>
    <snow-button
      variant="borderless"
      class="w-100"
      :class="customClass"
      :text="text"
      @click="onClick"
    >
    </snow-button>
    <snow-dialog
      v-model="modal"
      v-bind="dialogProps"
      @action="dialogAction"
      @secondary-action="dialogSecondaryAction"
    />
  </div>
</template>
<script>
export default {
  props: {
    icon: {
      type: String,
      default: ""
    },
    customClass: {
      type: String,
      default: ""
    },
    text: {
      type: String,
      default: ""
    },
    action: {
      type: Function,
      default: null
    },
    event: {
      type: String,
      default: ""
    },
    confirmation: {
      type: Object,
      default: null
    },
    dialog: {
      type: Object,
      default: null
    }
  },
  data() {
    return {
      modal: false,
      dialogProps: this.confirmation || this.dialog || {}
    };
  },
  methods: {
    onClick() {
      this.$emit("toggle");

      if (this.action) {
        this.action();
        return;
      } else if (this.confirmation) {
        this.modal = true;
        return;
      }
      this.$emit("event", this.event);
    },

    dialogAction() {
      this.$emit("event", this.event);
      this.modal = false;
    },
    dialogSecondaryAction() {
      this.modal = false;
    }
  }
};
</script>
